import React, {useState} from 'react';
import userService from "../../../../../../../services/web/user-service.js";
import AlertMessages from "../../../../../../../components/messages/alert-message.js";
import projectUtils from "../../../../../../../utils/project-utils.js";
import deviceService from "../../../../../../../services/web/device-service.js";
import SelectComponent from "../../../../../../../components/select/select-component.jsx";
import {getAssetPath} from "../../../../../../../utils/get-asset-path.js";
import Button from "../../../../../../../components/button/button.jsx"
import {Card} from "../../../../../../../components/card/card.jsx"
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal);

const DevicesAppCard = ({target, title, dt_activation, authorized, device, lanes, icon, setDevices, myUser}) => {
    const [lane, setLane] = useState(target === "plc" ? device?.pcl : device?.agentLane);
    const [hasLane, setHasLane] = useState(!!device?.pcl)
    const [disabled, setDisabled] = useState(false);

    const saveLaneCode = () => {
        const laneId = lane?.value || null

        const formData = new FormData();
        formData.append("app", target);
        formData.append("device_id", device.id);
        if (laneId) formData.append("lane_code", laneId);

        userService.updateLaneCode(formData)
            .then(() => {
                setHasLane(!!laneId);

                setDevices(prev =>
                    prev.map(p => (
                        {
                            ...p,
                            pcl_lane_code: device.id === p.id ? laneId : p.pcl_lane_code,
                            pcl: device.id === p.id ? lane : p.lane
                        }
                    ))
                );
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
    }

    const handleApp = () => {
        if (disabled) return;

        if (target === "pcl" && !hasLane) {
            projectUtils.swalErrorMessage("", "O campo \"Faixa\" é obrigatório.", "Ok");
            return;
        }

        const formData = new FormData();
        formData.append("device_id", device.id);
        formData.append("app", target);
        setDisabled(true);

        userService.revokeAuthorizeApp(formData, authorized ? "revoke-app" : "authorize-app")
            .then(() => {
                setDevices(prev =>
                    prev.map(p => (
                        {
                            ...p,
                            [target + "Authorized"]: p.id === device.id ? !authorized : p[target + "Authorized"]
                        }
                    ))
                );

                if (authorized) {
                    setLane(null);
                    setHasLane(false);
                }
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setDisabled(false))
    }

    const getCode = async () => {
        if (!authorized) return;

        const code = await deviceService.getCode(target, device.id)
            .then((data) => data.code)
            .catch(() => "");

        let applicationName = '';
        switch (target) {
            case 'abordagem':
                applicationName = 'App Abordagem';
                break;
            case 'monitoramento':
                applicationName = 'App Alarmes';
                break;
            case 'despacho':
                applicationName = 'App Despacho';
                break;
            case 'pcl':
                applicationName = 'App Captura Móvel';
                break;
            case 'agent':
                applicationName = 'App Agente';
                break;
        }

        let text = "Abra o aplicativo para gera-lo";
        if (code !== '') text = code;

        MySwal.fire({
            icon: 'warning',
            type: 'info',
            title: `<div id="swal-title">${applicationName}</div>`,
            html: `<h3>Código de ativação:</h3> ${text}`,
            confirmButtonColor: '#063A6C',
            confirmButtonText: 'OK',
            showCancelButton: false,
            cancelButtonColor: "#c10007",
        });
    }

    return (
        <Card className={"border-l-[5px] border-[#030b17] text-blue-900 min-h-[13.25rem] h-[232px] " +
            (["abordagem", "despacho"].includes(target)  ? "border-l-[#BEBEBE] !bg-[#f3f3f3]" : (authorized ? dt_activation ? "border-l-[#198754]" : "border-l-[#ed9c28]" : "border-l-[#dc4c64]"))}>
            <div className='grid grid-cols-12 gap-4 mt-4 p-5'>
                <div className="content-center flex justify-center col-span-3">
                    <img src={getAssetPath(icon)} alt='...' className="h-[70px] align-middle w-auto"/>
                </div>
                <div className={"col-span-9"}>
                    <div>
                        <h3 className={"mt-[5px] font-semibold text-[16px] text-[#031B34]"}>
                            {title}
                            {
                                !["abordagem", "despacho"].includes(target) &&
                                <p className={"italic font-normal text-[13px] mt-1"}>
                                    {
                                        authorized ? dt_activation ? `Ativado em ${new Date(dt_activation).toLocaleString()}` : 'Pendente de ativação' : ""
                                    }
                                    &nbsp;
                                </p>
                            }
                        </h3>
                        {
                            target === "abordagem" ? (
                                <div className={"mt-4"}>
                                    <p>Descontinuado. <br/>O módulo Abordagem agora está no App Agente.</p>

                                </div>
                            ) : target === "despacho" ? (
                                <div className={"mt-4"}>
                                    <p>Descontinuado. <br/>O módulo Despacho agora está no App Agente.</p>

                                </div>
                            ): (
                                <div className="flex gap-2 mt-1">
                                    {
                                        !myUser &&
                                        <span
                                            className={"underline cursor-pointer text-[#031b34]" + (disabled ? "  opacity-50" : "")}
                                            onClick={() => handleApp()}>
                                        {authorized ? "Revogar" : "Autorizar"}
                                    </span>
                                    }

                                    <span
                                        className={"underline cursor-pointer text-[#031b34]" + (!authorized ? " opacity-50" : "")}
                                        onClick={() => getCode()}>
                                    Exibir código
                                </span>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            {
                (target === "pcl" || target === "agent") &&
                <div className={"p-5 border-t-[3px] border-[#f5f5f5]"}>
                    {
                        target === "agent" && <p className={"mb-2"}>Configuração para Captura Móvel:</p>
                    }

                    <div className="flex justify-between">
                        <div style={{width: myUser ? "100%" : "calc(100% - 115px)"}}>
                            <SelectComponent
                                value={lane}
                                options={lanes}
                                label={"Câmera"}
                                onChange={(value) => setLane(value)}
                                isDisabled={myUser}
                            />
                        </div>

                        {
                            !myUser &&
                            <div style={{width: "100px"}}>
                                <Button className={"w-full"} disabled={target !== "agent" && (!lane || device?.pcl === lane)}
                                        onClick={() => saveLaneCode()}>
                                    Aplicar
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            }
        </Card>
    );
};

export default DevicesAppCard;